import { FirmwarePackage } from '@shure/shared/models';

export enum FirmwareUpdateStage {
	/** The firmware update was canceled. */
	Canceled = 'CANCELED',
	/** The firmware update is complete. */
	Complete = 'COMPLETE',
	/** An error occurred during the firmware update. */
	Error = 'ERROR',
	/** The firmware package is in the process of being applied */
	Executing = 'EXECUTING',
	/** Device is idle and available for updates */
	Idle = 'IDLE',
	/** The request to update the device was received, but has not started yet. */
	Pending = 'PENDING',

	/** The device is being reserved for a firmware update. */
	DeviceReserved = 'DEVICE_RESERVED',
	/** The device is installing the firmware package. */
	Installing = 'INSTALLING',
	/** The firmware package is being validated by the device before installation. */
	PreInstallValidating = 'PRE_INSTALL_VALIDATING',
	/** The device is rebooting. */
	Rebooting = 'REBOOTING',
	/** The firmware package is being transferred to the device. */
	TransferringFiles = 'TRANSFERRING_FILES',
	/** The device is verifying that the firmware package was installed correctly. */
	Verifying = 'VERIFYING'
}

export type FirmwareUpdateExecutingStage =
	| FirmwareUpdateStage.DeviceReserved
	| FirmwareUpdateStage.PreInstallValidating
	| FirmwareUpdateStage.TransferringFiles
	| FirmwareUpdateStage.Installing
	| FirmwareUpdateStage.Rebooting
	| FirmwareUpdateStage.Verifying;

export enum FirmwareUpdateStatus {
	/** The device aborted the firmware update. */
	Aborted = 'ABORTED',
	/** The firmware update was canceled. */
	Canceled = 'CANCELED',
	/** There was a connectivity issue. */
	ConnectivityLoss = 'CONNECTIVITY_LOSS',
	/** The firmware package was corrupted locally or in transfer to the device. */
	CorruptPackage = 'CORRUPT_PACKAGE',

	DanteLocked = 'DANTE_LOCKED',

	DanteNetworkMismatch = 'DANTE_NETWORK_MISMATCH',
	/** The device is unavailable for a firmware update. */
	DeviceBusy = 'DEVICE_BUSY',
	/** The device cannot be found. */
	DeviceNotFound = 'DEVICE_NOT_FOUND',
	DeviceRejectedPackage = 'DEVICE_REJECTED_PACKAGE',
	/** An error occurred while transferring the firmware package to the device. */
	FileTransferError = 'FILE_TRANSFER_ERROR',
	/** An error occurred while the device was installing the firmware package. */
	InstallationError = 'INSTALLATION_ERROR',
	/** The device does not support the specified firmware package. */
	InvalidPackage = 'INVALID_PACKAGE',

	MissingProxy = 'MISSING_PROXY',

	NetworkLocked = 'NETWORK_LOCKED',

	NotConnectionViaUsb = 'NOT_CONNECTED_VIA_USB',

	NotDocked = 'NOT_DOCKED',
	/** The firmware update is complete. */
	Success = 'SUCCESS',

	QuotaExceeded = 'QUOTA_EXCEEDED',
	/** An unknown error occurred. */
	UnknownError = 'UNKNOWN_ERROR',

	UpdateInProgress = 'UPDATE_IN_PROGRESS',
	/** An error occurred while the device was verifying the installation. */
	VerificationError = 'VERIFICATION_ERROR'
}

export interface FirmwareUpdateProgress {
	package: FirmwarePackage;
	percentComplete: number;
	stage: FirmwareUpdateStage;
	executionStage?: FirmwareUpdateExecutingStage;
	status: FirmwareUpdateStatus;
}
